var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.384 7.584a.812.812 0 0 1 0 1.132l-4.829 4.539a.775.775 0 0 1-1.11 0L.614 8.716a.812.812 0 0 1 0-1.132.775.775 0 0 1 1.11 0l3.49 3.17V1.458c0-.442.35-.8.785-.8.433 0 .785.358.785.8v9.298l3.488-3.171a.775.775 0 0 1 1.111 0Z",
    fill: "currentColor"
  })));
};
export default SvgArrowDown;